<section>
  <form [formGroup]="form">
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap mt-6 mt-sm-8"
    >
      <h1
        class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center"
      >
        <span data-testid="study-record-heading">เวลาเรียนย้อนหลัง{{form.value.back_date ? ` ${form.value.back_date} วัน` : 'ทั้งหมด'}}</span>
      </h1>
    </div>
    <div class="d-flex flex-column flex-sm-row justify-content-between py-4">
      <div class="col-12 col-sm-6 col-md-4 mb-4 mb-sm-0">
        <app-select
          name="course_id"
          formControlName="course_id"
          placeholder="APP.COURSES"
          label="APP.COURSES"
          bindLabel="course_name"
          [labelMode]="LabelMode.INLINE"
          [url]="`/student_courses/${monitorStudent()?.id? `?student_id=${monitorStudent()?.id}&` : '?'}is_activated=true`"
        ></app-select>
      </div>
      <div class="card-toolbar">
        <ul
          class="nav justify-content-center justify-content-sm-end"
          role="tablist"
        >
          @for (item of optionDates; track $index) {
          <li class="nav-item" role="presentation">
            <a
              class="nav-link btn btn-sm btn-color-muted btn-active btn-active-light fw-semibold px-4 me-1"
              [ngClass]="{ active: $index === 0 }"
              data-bs-toggle="tab"
              aria-selected="false"
              role="tab"
              tabindex="-1"
              (click)="filterDate(item.value)"
              >{{ item.name }}</a
            >
          </li>
          }
        </ul>
      </div>
    </div>
    @if(isStudent() && isLoading() || !isStudent() && isLoading() &&
    monitorStudent()?.id ){
    <div class="min-h-325px w-100 skeleton"></div>
    <!-- <status-loading loadingClass="min-h-60"></status-loading> -->
    }@else{

    <app-column-chart data-testid="study-chart" [data]="durationInfo()!"></app-column-chart>

    }
    <div class="separator my-4"></div>
    <div
      class="page-title d-flex flex-column justify-content-center flex-wrap mt-8"
    >
      <h1
        class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-0"
      >
        ประวัติการเรียน
      </h1>
    </div>

    @if(isLoading() && firstInitLoading()){
    <div class="min-h-250px w-100 mt-6 skeleton"></div>
    <!-- <status-loading loadingClass="min-h-60"></status-loading> -->
    }@else{

    <app-table-widget
      data-testid="study-activity"
      [dataSource]="activitiesSource()"
      [dataColumns]="dataColumns"
      [isLoading]="tableLoading()"
      (tableChange)="onTableChange($event)"
      [showCardSpace]="false"
      containerClass="''"
      [rowClick]="false"
    ></app-table-widget>

    }
  </form>
</section>
